/**
 * @generated SignedSource<<2a3f29127982190aab34405797a2373b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getLanguageAnnotations_pdpMetaItems$data = {
  readonly languageAnnotations: ReadonlyArray<{
    readonly href: string | null;
    readonly hrefLang: string | null;
  } | null> | null;
  readonly " $fragmentType": "getLanguageAnnotations_pdpMetaItems";
};
export type getLanguageAnnotations_pdpMetaItems$key = {
  readonly " $data"?: getLanguageAnnotations_pdpMetaItems$data;
  readonly " $fragmentSpreads": FragmentRefs<"getLanguageAnnotations_pdpMetaItems">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getLanguageAnnotations_pdpMetaItems"
};

(node as any).hash = "8fb06e65d26bec8ebbea2f0c4868a4bd";

export default node;
